import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';

export default class ScriptSureWebhookLog extends BackboneElement {
    static __className = 'ScriptSureWebhookLog';

    __objectStructure = {
        receivedAt: String,
        event: String,
        pharmacy: String,
        prescriber: String,
        drugFormat: String,
    };

    constructor(constructJson, className = 'ScriptSureWebhookLog') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
